import React from 'react';
import {graphql, useStaticQuery} from 'gatsby';
import {GatsbyImage, IGatsbyImageData} from 'gatsby-plugin-image';
import {StarRating} from '../StarRating';
import {thinMargins} from '../../constants';
import {ParentReview} from '../../types';
import {StyledStructuredText} from '../../components/common/StyledStructuredText';
import {MobileCarousel} from '../../components/common/MobileCarousel';
import {Text} from '../../components/common';

const ParentReviewCard = ({title, reviewerName, review}: ParentReview) => {
  return (
    <div className="min-w-[100%] px-[5%]">
      <div className="bg-white rounded-[1.5rem] py-8 px-4 md:px-6 text-black h-full flex flex-col justify-between gap-6 lg:mx-auto">
        <div>
          <h3 className="text-largebodymob lg:text-subtitlesmall font-title">
            {title}
          </h3>
          <StyledStructuredText data={review.value} />
        </div>
        <Text as="p" variant="SmallBodyBold">
          {reviewerName}&nbsp;
        </Text>
      </div>
    </div>
  );
};

interface IParentReviews {
  reviews: ParentReview[];
  appRating: number;
  title: string;
}

export const ParentReviews = ({reviews, appRating, title}: IParentReviews) => {
  const data = useStaticQuery<Queries.ParentReviewsImageQuery>(graphql`
    query ParentReviewsImage {
      file(relativePath: {eq: "parents/parent-reviews.png"}) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE, quality: 90)
        }
      }
    }
  `);
  const reviewBackground = data.file?.childImageSharp
    ?.gatsbyImageData as unknown as IGatsbyImageData;

  return (
    <div className="relative py-28 max-w-full overflow-hidden">
      <GatsbyImage
        image={reviewBackground}
        alt=""
        objectFit="cover"
        objectPosition="center"
        style={{position: 'absolute', inset: 0}}
      />
      <div
        className={`relative ${thinMargins} flex flex-col justify-center items-center gap-6`}>
        <Text as="h2" variant="Title" className="text-white text-center">
          {title}
        </Text>
        <StarRating rating={appRating} starColor={'yellow'} mode="light" />
        {/* Desktop */}
        <div className="hidden lg:flex gap-5 min-h-[22.6rem] max-h-fit ">
          {reviews.map((r, i) => (
            <div className="w-1/3" key={i}>
              <ParentReviewCard
                title={r.title}
                reviewerName={r.reviewerName}
                key={i}
                review={r.review}
              />
            </div>
          ))}
        </div>

        {/* Mobile carousel */}
        <MobileCarousel
          slides={reviews}
          autoplayIntervalMs={0}
          dotActiveClassName="bg-white bg-opacity-100"
          dotInactiveClassName="bg-white bg-opacity-40">
          {reviews.map((r, i) => (
            <ParentReviewCard
              title={r.title}
              reviewerName={r.reviewerName}
              key={i}
              review={r.review}
            />
          ))}
        </MobileCarousel>
      </div>
    </div>
  );
};
